import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SmartDesignButtonModule } from '@smartdesign/angular/button';
export * from '@smartdesign/angular/button';
import { SmartDesignButtonGroupModule } from '@smartdesign/angular/button-group';
export * from '@smartdesign/angular/button-group';
import { SmartDesignCheckboxModule } from '@smartdesign/angular/checkbox';
export * from '@smartdesign/angular/checkbox';
import { SmartDesignChipModule } from '@smartdesign/angular/chip';
export * from '@smartdesign/angular/chip';
import { SmartDesignDropdownModule } from '@smartdesign/angular/dropdown';
export * from '@smartdesign/angular/dropdown';
import { SmartDesignFormFieldModule } from '@smartdesign/angular/form-field';
export * from '@smartdesign/angular/form-field';
import { SmartDesignNativeSelectModule } from '@smartdesign/angular/native-select';
export * from '@smartdesign/angular/native-select';
import { SmartDesignRadioModule } from '@smartdesign/angular/radio';
export * from '@smartdesign/angular/radio';
import { SmartDesignRatingInputModule } from '@smartdesign/angular/rating-input';
export * from '@smartdesign/angular/rating-input';
import { SmartDesignShowNumberModule } from '@smartdesign/angular/show-number';
export * from '@smartdesign/angular/show-number';
import { SmartDesignToggleSwitchModule } from '@smartdesign/angular/toggle-switch';
export * from '@smartdesign/angular/toggle-switch';
import { SmartDesignBadgeModule } from '@smartdesign/angular/badge';
export * from '@smartdesign/angular/badge';
import { SmartDesignCardModule } from '@smartdesign/angular/card';
export * from '@smartdesign/angular/card';
import { SmartDesignCellModule } from '@smartdesign/angular/cell';
export * from '@smartdesign/angular/cell';
import { SmartDesignDataTableModule } from '@smartdesign/angular/data-table';
export * from '@smartdesign/angular/data-table';
import { SmartDesignDividerModule } from '@smartdesign/angular/divider';
export * from '@smartdesign/angular/divider';
import { SmartDesignExpansionPanelModule } from '@smartdesign/angular/expansion-panel';
export * from '@smartdesign/angular/expansion-panel';
import { SmartDesignReadMoreModule } from '@smartdesign/angular/read-more';
export * from '@smartdesign/angular/read-more';
import { SmartDesignTeaserModule } from '@smartdesign/angular/teaser';
export * from '@smartdesign/angular/teaser';
import { SmartDesignAlertboxModule } from '@smartdesign/angular/alertbox';
export * from '@smartdesign/angular/alertbox';
import { SmartDesignLoadingModule } from '@smartdesign/angular/loading';
export * from '@smartdesign/angular/loading';
import { SmartDesignSnackbarModule } from '@smartdesign/angular/snackbar';
export * from '@smartdesign/angular/snackbar';
import { SmartDesignStepItemModule } from '@smartdesign/angular/step-item';
export * from '@smartdesign/angular/step-item';
import { SmartDesignProgressbarModule } from '@smartdesign/angular/progressbar';
export * from '@smartdesign/angular/progressbar';
import { SmartDesignGridModule } from '@smartdesign/angular/grid';
export * from '@smartdesign/angular/grid';
import { SmartDesignAvatarModule } from '@smartdesign/angular/avatar';
export * from '@smartdesign/angular/avatar';
import { SmartDesignIconModule } from '@smartdesign/angular/icon';
export * from '@smartdesign/angular/icon';
import { SmartDesignMapModule } from '@smartdesign/angular/map';
export * from '@smartdesign/angular/map';
import { SmartDesignBreadcrumbModule } from '@smartdesign/angular/breadcrumb';
export * from '@smartdesign/angular/breadcrumb';
import { SmartDesignLinkModule } from '@smartdesign/angular/link';
export * from '@smartdesign/angular/link';
import { SmartDesignPaginationModule } from '@smartdesign/angular/pagination';
export * from '@smartdesign/angular/pagination';
import { SmartDesignTabModule } from '@smartdesign/angular/tab';
export * from '@smartdesign/angular/tab';
import { SmartDesignTabbarModule } from '@smartdesign/angular/tabbar';
export * from '@smartdesign/angular/tabbar';
import { SmartDesignActionbarModule } from '@smartdesign/angular/actionbar';
export * from '@smartdesign/angular/actionbar';
import { SmartDesignMenuModule } from '@smartdesign/angular/menu';
export * from '@smartdesign/angular/menu';
import { SmartDesignModalModule } from '@smartdesign/angular/modal';
export * from '@smartdesign/angular/modal';
import { SmartDesignPopoverModule } from '@smartdesign/angular/popover';
export * from '@smartdesign/angular/popover';
import { SmartDesignSocialShareModule } from '@smartdesign/angular/social-share';
export * from '@smartdesign/angular/social-share';
import { SmartDesignErrorPageModule } from '@smartdesign/angular/error-page';
export * from '@smartdesign/angular/error-page';
import { SmartDesignSeoLinklistModule } from '@smartdesign/angular/seo-linklist';
import { SmartDesignSearchCardModule } from '@smartdesign/angular/search-card';
export * from '@smartdesign/angular/search-card';
import { SmartDesignRatingMeterModule } from '@smartdesign/angular/rating-meter';
export * from '@smartdesign/angular/common';

/**
 * @deprecated Use explicit imports. see http://smart-design.gitlab-fue1.iwui.net/smart-design-angular/00_general/getting-started
 */
class SmartDesignAngularModule {
}
SmartDesignAngularModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignAngularModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmartDesignAngularModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignAngularModule, imports: [CommonModule,
        RouterModule,
        // Action & Input
        SmartDesignButtonModule,
        SmartDesignButtonGroupModule,
        SmartDesignCheckboxModule,
        SmartDesignChipModule,
        SmartDesignDropdownModule,
        SmartDesignFormFieldModule,
        SmartDesignNativeSelectModule,
        SmartDesignRadioModule,
        SmartDesignRatingInputModule,
        SmartDesignShowNumberModule,
        SmartDesignToggleSwitchModule,
        // content
        SmartDesignBadgeModule,
        SmartDesignCardModule,
        SmartDesignCellModule,
        SmartDesignDataTableModule,
        SmartDesignDividerModule,
        SmartDesignExpansionPanelModule,
        SmartDesignReadMoreModule,
        SmartDesignTeaserModule,
        SmartDesignRatingMeterModule,
        // feedback
        SmartDesignAlertboxModule,
        SmartDesignLoadingModule,
        SmartDesignSnackbarModule,
        SmartDesignStepItemModule,
        SmartDesignProgressbarModule,
        // fundamentals
        SmartDesignGridModule,
        // media
        SmartDesignAvatarModule,
        SmartDesignIconModule,
        SmartDesignMapModule,
        // navigation
        SmartDesignBreadcrumbModule,
        SmartDesignLinkModule,
        SmartDesignPaginationModule,
        SmartDesignTabModule,
        SmartDesignTabbarModule,
        SmartDesignSeoLinklistModule,
        SmartDesignSearchCardModule,
        // overlays
        SmartDesignActionbarModule,
        SmartDesignMenuModule,
        SmartDesignModalModule,
        SmartDesignPopoverModule,
        SmartDesignSocialShareModule,
        // template
        SmartDesignErrorPageModule], exports: [
        // Action & Input
        SmartDesignButtonModule,
        SmartDesignButtonGroupModule,
        SmartDesignCheckboxModule,
        SmartDesignChipModule,
        SmartDesignDropdownModule,
        SmartDesignFormFieldModule,
        SmartDesignNativeSelectModule,
        SmartDesignRadioModule,
        SmartDesignRatingInputModule,
        SmartDesignShowNumberModule,
        SmartDesignToggleSwitchModule,
        // content
        SmartDesignBadgeModule,
        SmartDesignCardModule,
        SmartDesignCellModule,
        SmartDesignDataTableModule,
        SmartDesignDividerModule,
        SmartDesignExpansionPanelModule,
        SmartDesignReadMoreModule,
        SmartDesignTeaserModule,
        SmartDesignRatingMeterModule,
        // feedback
        SmartDesignAlertboxModule,
        SmartDesignLoadingModule,
        SmartDesignSnackbarModule,
        SmartDesignStepItemModule,
        SmartDesignProgressbarModule,
        // fundamentals
        SmartDesignGridModule,
        // media
        SmartDesignAvatarModule,
        SmartDesignIconModule,
        SmartDesignMapModule,
        // navigation
        SmartDesignBreadcrumbModule,
        SmartDesignLinkModule,
        SmartDesignPaginationModule,
        SmartDesignTabModule,
        SmartDesignTabbarModule,
        SmartDesignSeoLinklistModule,
        SmartDesignSearchCardModule,
        // overlays
        SmartDesignActionbarModule,
        SmartDesignMenuModule,
        SmartDesignModalModule,
        SmartDesignPopoverModule,
        SmartDesignSocialShareModule,
        // template
        SmartDesignErrorPageModule
    ] });
SmartDesignAngularModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignAngularModule, imports: [[
            CommonModule,
            RouterModule,
            // Action & Input
            SmartDesignButtonModule,
            SmartDesignButtonGroupModule,
            SmartDesignCheckboxModule,
            SmartDesignChipModule,
            SmartDesignDropdownModule,
            SmartDesignFormFieldModule,
            SmartDesignNativeSelectModule,
            SmartDesignRadioModule,
            SmartDesignRatingInputModule,
            SmartDesignShowNumberModule,
            SmartDesignToggleSwitchModule,
            // content
            SmartDesignBadgeModule,
            SmartDesignCardModule,
            SmartDesignCellModule,
            SmartDesignDataTableModule,
            SmartDesignDividerModule,
            SmartDesignExpansionPanelModule,
            SmartDesignReadMoreModule,
            SmartDesignTeaserModule,
            SmartDesignRatingMeterModule,
            // feedback
            SmartDesignAlertboxModule,
            SmartDesignLoadingModule,
            SmartDesignSnackbarModule,
            SmartDesignStepItemModule,
            SmartDesignProgressbarModule,
            // fundamentals
            SmartDesignGridModule,
            // media
            SmartDesignAvatarModule,
            SmartDesignIconModule,
            SmartDesignMapModule,
            // navigation
            SmartDesignBreadcrumbModule,
            SmartDesignLinkModule,
            SmartDesignPaginationModule,
            SmartDesignTabModule,
            SmartDesignTabbarModule,
            SmartDesignSeoLinklistModule,
            SmartDesignSearchCardModule,
            // overlays
            SmartDesignActionbarModule,
            SmartDesignMenuModule,
            SmartDesignModalModule,
            SmartDesignPopoverModule,
            SmartDesignSocialShareModule,
            // template
            SmartDesignErrorPageModule,
        ],
        // Action & Input
        SmartDesignButtonModule,
        SmartDesignButtonGroupModule,
        SmartDesignCheckboxModule,
        SmartDesignChipModule,
        SmartDesignDropdownModule,
        SmartDesignFormFieldModule,
        SmartDesignNativeSelectModule,
        SmartDesignRadioModule,
        SmartDesignRatingInputModule,
        SmartDesignShowNumberModule,
        SmartDesignToggleSwitchModule,
        // content
        SmartDesignBadgeModule,
        SmartDesignCardModule,
        SmartDesignCellModule,
        SmartDesignDataTableModule,
        SmartDesignDividerModule,
        SmartDesignExpansionPanelModule,
        SmartDesignReadMoreModule,
        SmartDesignTeaserModule,
        SmartDesignRatingMeterModule,
        // feedback
        SmartDesignAlertboxModule,
        SmartDesignLoadingModule,
        SmartDesignSnackbarModule,
        SmartDesignStepItemModule,
        SmartDesignProgressbarModule,
        // fundamentals
        SmartDesignGridModule,
        // media
        SmartDesignAvatarModule,
        SmartDesignIconModule,
        SmartDesignMapModule,
        // navigation
        SmartDesignBreadcrumbModule,
        SmartDesignLinkModule,
        SmartDesignPaginationModule,
        SmartDesignTabModule,
        SmartDesignTabbarModule,
        SmartDesignSeoLinklistModule,
        SmartDesignSearchCardModule,
        // overlays
        SmartDesignActionbarModule,
        SmartDesignMenuModule,
        SmartDesignModalModule,
        SmartDesignPopoverModule,
        SmartDesignSocialShareModule,
        // template
        SmartDesignErrorPageModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignAngularModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        // Action & Input
                        SmartDesignButtonModule,
                        SmartDesignButtonGroupModule,
                        SmartDesignCheckboxModule,
                        SmartDesignChipModule,
                        SmartDesignDropdownModule,
                        SmartDesignFormFieldModule,
                        SmartDesignNativeSelectModule,
                        SmartDesignRadioModule,
                        SmartDesignRatingInputModule,
                        SmartDesignShowNumberModule,
                        SmartDesignToggleSwitchModule,
                        // content
                        SmartDesignBadgeModule,
                        SmartDesignCardModule,
                        SmartDesignCellModule,
                        SmartDesignDataTableModule,
                        SmartDesignDividerModule,
                        SmartDesignExpansionPanelModule,
                        SmartDesignReadMoreModule,
                        SmartDesignTeaserModule,
                        SmartDesignRatingMeterModule,
                        // feedback
                        SmartDesignAlertboxModule,
                        SmartDesignLoadingModule,
                        SmartDesignSnackbarModule,
                        SmartDesignStepItemModule,
                        SmartDesignProgressbarModule,
                        // fundamentals
                        SmartDesignGridModule,
                        // media
                        SmartDesignAvatarModule,
                        SmartDesignIconModule,
                        SmartDesignMapModule,
                        // navigation
                        SmartDesignBreadcrumbModule,
                        SmartDesignLinkModule,
                        SmartDesignPaginationModule,
                        SmartDesignTabModule,
                        SmartDesignTabbarModule,
                        SmartDesignSeoLinklistModule,
                        SmartDesignSearchCardModule,
                        // overlays
                        SmartDesignActionbarModule,
                        SmartDesignMenuModule,
                        SmartDesignModalModule,
                        SmartDesignPopoverModule,
                        SmartDesignSocialShareModule,
                        // template
                        SmartDesignErrorPageModule,
                    ],
                    exports: [
                        // Action & Input
                        SmartDesignButtonModule,
                        SmartDesignButtonGroupModule,
                        SmartDesignCheckboxModule,
                        SmartDesignChipModule,
                        SmartDesignDropdownModule,
                        SmartDesignFormFieldModule,
                        SmartDesignNativeSelectModule,
                        SmartDesignRadioModule,
                        SmartDesignRatingInputModule,
                        SmartDesignShowNumberModule,
                        SmartDesignToggleSwitchModule,
                        // content
                        SmartDesignBadgeModule,
                        SmartDesignCardModule,
                        SmartDesignCellModule,
                        SmartDesignDataTableModule,
                        SmartDesignDividerModule,
                        SmartDesignExpansionPanelModule,
                        SmartDesignReadMoreModule,
                        SmartDesignTeaserModule,
                        SmartDesignRatingMeterModule,
                        // feedback
                        SmartDesignAlertboxModule,
                        SmartDesignLoadingModule,
                        SmartDesignSnackbarModule,
                        SmartDesignStepItemModule,
                        SmartDesignProgressbarModule,
                        // fundamentals
                        SmartDesignGridModule,
                        // media
                        SmartDesignAvatarModule,
                        SmartDesignIconModule,
                        SmartDesignMapModule,
                        // navigation
                        SmartDesignBreadcrumbModule,
                        SmartDesignLinkModule,
                        SmartDesignPaginationModule,
                        SmartDesignTabModule,
                        SmartDesignTabbarModule,
                        SmartDesignSeoLinklistModule,
                        SmartDesignSearchCardModule,
                        // overlays
                        SmartDesignActionbarModule,
                        SmartDesignMenuModule,
                        SmartDesignModalModule,
                        SmartDesignPopoverModule,
                        SmartDesignSocialShareModule,
                        // template
                        SmartDesignErrorPageModule,
                    ],
                }]
        }] });

/*
 * Public API Surface of angular
 */
// todo: remove in next breaking change. see material for workaround

/**
 * Generated bundle index. Do not edit.
 */

export { SmartDesignAngularModule };
